import { Component } from '@angular/core';
import { AlertController, ModalController } from 'ionic-angular';

import { UserModel, UserMemoModel } from '../../models/models';
import { ConfigurationProvider, UserMemoProvider, UserProvider } from '../../providers/providers';
import { MemoEditPage } from './memo-edit';

@Component({
  selector: 'page-memo',
  templateUrl: 'memo.html',
})
export class MemoPage {
  isLoaded: boolean = false;
  items: UserMemoModel[];
  user: UserModel;

  constructor(
    private alertCtrl: AlertController,
    private config: ConfigurationProvider,
    private modalCtrl: ModalController,
    private userMemoProvider: UserMemoProvider,
    private userProvider: UserProvider) {
  }

  doEdit(item: UserMemoModel = new UserMemoModel()) {
    let modal = this.modalCtrl.create(MemoEditPage, { 
      item: item,
      user: this.user
    });
    modal.present();

    modal.onDidDismiss(data => {
      if (data && data.saved) {
        this.config.showToast('"' + data.name + '" saved!');
      }
    });
  }

  doRemove(item: UserMemoModel) {
    let confirm = this.alertCtrl.create({
      title: `Remove ${item.Name}?`,
      message: 'Are you sure?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove',
          handler: () => {
            this.config.showLoading('Removing...');
            this.userMemoProvider.Remove(item).then((items: UserMemoModel[]) => {
              this.config.showToast(item.Name + ' removed!');
              this.items = items;
              this.config.dismissLoading();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  ionViewDidLoad() {
    this.loadView();
  }

  loadView() {
    this.user = this.userProvider.Get();
    this.config.showLoading();
    this.userMemoProvider.List(1).then((items: UserMemoModel[]) => {
      this.items = items;
      this.isLoaded = true;
      this.config.dismissLoading();
    });
  }

  itemShowDetails(item) {
    if (!item.icon) {
      item.icon = 'arrow-dropdown';
      item.showDetails = false;
    }
    return item;
  }

  toggleDetails(item) {
    if (item.showDetails) {
      item.showDetails = false;
      item.icon = 'arrow-dropdown';
    }
    else {
      item.showDetails = true;
      item.icon = 'arrow-dropup';
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/memo/memo.ts